import { render, staticRenderFns } from "./InputStake.vue?vue&type=template&id=3e179f8b&scoped=true"
import script from "./InputStake.vue?vue&type=script&lang=js"
export * from "./InputStake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e179f8b",
  null
  
)

/* custom blocks */
import block0 from "./InputStake.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports